export const iconFontAwesomeShoppingHandshake = (
	<i className="fa-solid fa-handshake"></i>
);
